module.exports = __webpack_public_path__ + "img/premium_blue.cced58e7.svg";